import { render, staticRenderFns } from "./ad-log-modal.vue?vue&type=template&id=05620cd6&scoped=true&"
import script from "./ad-log-modal.vue?vue&type=script&lang=js&"
export * from "./ad-log-modal.vue?vue&type=script&lang=js&"
import style0 from "./ad-log-modal.vue?vue&type=style&index=0&id=05620cd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05620cd6",
  null
  
)

export default component.exports